import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, CreateCredentialsParams, CredentialsCheckerMetadata, CredentialExternalInfo, DataEditorView, SystemCredentialInfo }
    from '@m4u-angular/base/entities/BaseEntities';
import { CredentialActivityEndpoint } from '@m4u-angular/core/endpoints/credential-activity.endpoint';

class State extends BaseState {

}

@Component({
    providers: ServiceBagServices,
    selector: 'app-data-view-grid',
    templateUrl: './data-view-grid.component.html',
})
export class DataViewGridComponent extends BaseGridComponent<SystemCredentialInfo, State> {
    @Input() Views: DataEditorView[];
    @ViewChild('grid') grid: any;
    @Output() OnSelectionChanged = new EventEmitter<CredentialExternalInfo[]>();

    constructor(A: ServiceBagService, private credentialActivityEndpoint: CredentialActivityEndpoint) {
        super(A, 'DataViewGridComponent', SystemCredentialInfo, State);

    }

    OnGridSelectionChanged(event: any) {
        this.OnSelectionChanged.emit(this.grid.instance?.getSelectedRowsData());
    }
}
